import {OnDestroy, OnInit} from '@angular/core';
import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaCardDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaTagDirective} from 'angular-awesome';
import {WaDividerDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-framework-jquery-ui',
	templateUrl:'./JQueryUIFrameworkPage.html',
	styles: [],
	styleUrls:['./JQueryUIFrameworkPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaCardDirective,
		WaTextDirective,
		WaTagDirective,
		WaDividerDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQueryUIFrameworkPage
{
	useGradle = false;
	private _storageListener: any;
	private _customListener: any;
	mdContent_44 = `\`\`\`xml
<dependency>
  <groupId>com.jwebmp.plugins</groupId>
  <artifactId>jquery-ui</artifactId>
</dependency>
\`\`\``;
	mdContent_45 = `\`\`\`kotlin
implementation("com.jwebmp.plugins:jquery-ui:2.0.0-SNAPSHOT")
\`\`\``;
	mdContent_46 = `\`\`\`json
"jquery-ui": "^1.14.2"
\`\`\``;
	mdContent_47 = `\`\`\`java
// Accordion with animation
JQUIAccordion accordion = new JQUIAccordion();
accordion.addAccordianTab(tab1);
accordion.addAccordianTab(tab2);
accordion.getOptions().setCollapsible(true);
accordion.getOptions().getAnimate()
    .setEasing(JQEasingEffects.easeInBack);

// Autocomplete with AJAX
JQUIAutoComplete ac = new JQUIAutoComplete("search");
ac.getOptions().setAjax(true, ac);
\`\`\``;
	ngOnInit() {
	    const saved = localStorage.getItem('jwebmp-build-tool');
	    if (saved) { this.useGradle = saved === 'gradle'; }
	    this._storageListener = (e: StorageEvent) => {
	        if (e.key === 'jwebmp-build-tool') {
	            this.useGradle = e.newValue === 'gradle';
	        }
	    };
	    this._customListener = (e: any) => {
	        this.useGradle = e.detail;
	    };
	    window.addEventListener('storage', this._storageListener);
	    window.addEventListener('jwebmp-build-tool-change', this._customListener);
	}
	ngOnDestroy() {
	    window.removeEventListener('storage', this._storageListener);
	    window.removeEventListener('jwebmp-build-tool-change', this._customListener);
	}

}
